var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMethods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1598_6605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2635 2.61035H17.4697C16.9724 2.61035 16.5189 2.8885 16.2849 3.34233L14.4711 6.85585L12.9938 7.47071L9.22001 6.25562C8.73732 6.10922 8.22537 6.22634 7.87432 6.57769L5.35845 9.09571C5.0074 9.44706 4.87576 9.97409 5.03666 10.4426L6.23608 14.2196L5.62174 15.7128L2.11124 17.5281C1.67242 17.7477 1.37988 18.2308 1.37988 18.714V22.2714C1.37988 22.7691 1.6578 23.223 2.11124 23.4572L5.62174 25.2725L6.23608 26.7511L5.03666 30.5428C4.89039 31.0259 5.0074 31.5383 5.35845 31.8896L7.87432 34.4076C8.22537 34.759 8.75194 34.8908 9.22001 34.7444L12.9938 33.5293L14.4858 34.1441L16.2995 37.6723C16.4165 37.9065 16.6213 38.0968 16.8554 38.2286C18.0402 38.3311 19.2396 38.3896 20.4536 38.3896",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2086 40C23.0972 40 23.8176 39.279 23.8176 38.3897C23.8176 37.5003 23.0972 36.7793 22.2086 36.7793C21.32 36.7793 20.5996 37.5003 20.5996 38.3897C20.5996 39.279 21.32 40 22.2086 40Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8727 4.22072C22.7613 4.22072 23.4816 3.49974 23.4816 2.61036C23.4816 1.72098 22.7613 1 21.8727 1C20.984 1 20.2637 1.72098 20.2637 2.61036C20.2637 3.49974 20.984 4.22072 21.8727 4.22072Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4879 11.5845C31.3765 11.5845 32.0969 10.8635 32.0969 9.97413C32.0969 9.08475 31.3765 8.36377 30.4879 8.36377C29.5993 8.36377 28.8789 9.08475 28.8789 9.97413C28.8789 10.8635 29.5993 11.5845 30.4879 11.5845Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0113 18.3775C37.8999 18.3775 38.6203 17.6565 38.6203 16.7671C38.6203 15.8777 37.8999 15.1567 37.0113 15.1567C36.1227 15.1567 35.4023 15.8777 35.4023 16.7671C35.4023 17.6565 36.1227 18.3775 37.0113 18.3775Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4625 25.0088C33.3511 25.0088 34.0715 24.2878 34.0715 23.3984C34.0715 22.5091 33.3511 21.7881 32.4625 21.7881C31.5739 21.7881 30.8535 22.5091 30.8535 23.3984C30.8535 24.2878 31.5739 25.0088 32.4625 25.0088Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3789 20.5293H29.2297L31.4384 22.5496",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5933 16.7671H32.0974L29.2305 20.5295",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8535 11.5845L32.0968 16.7669",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1374 24.7601C21.472 24.7601 23.3646 22.8658 23.3646 20.5292C23.3646 18.1926 21.472 16.2983 19.1374 16.2983C16.8028 16.2983 14.9102 18.1926 14.9102 20.5292C14.9102 22.8658 16.8028 24.7601 19.1374 24.7601Z",
    stroke: "#2D2D2D",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1598_6605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethods);
export default __webpack_public_path__ + "static/media/methods.1157df6f52847386ce82fab2e31fb2b8.svg";
export { ForwardRef as ReactComponent };